/**
 * Which calendar rows the viewer may book time away on by clicking/dragging
 * (TASK-181). Mirrors the server's scope resolution (`getPermissionsForTarget`):
 * own row always, `reports` covers the direct reports only (the "Otsealluvad"
 * scope — TASK-476), `everyone` covers all rows. The server re-checks
 * permissions on submit — this only gates the UI affordance.
 */
import type { TimeAwayManageScope } from './portal-api.js'

export const computeBookableEmployeeIds = (
    roster: { id: number; manager_id: number | null }[],
    myEmployeeId: number | null,
    scope: TimeAwayManageScope,
): Set<number> => {
    const ids = new Set<number>()

    if (scope === 'everyone') {
        for (const emp of roster) ids.add(emp.id)
        return ids
    }

    // Booking for oneself needs no scope at all — the server allows self
    // requests unconditionally.
    if (myEmployeeId === null) return ids
    ids.add(myEmployeeId)

    if (scope !== 'reports') return ids

    for (const emp of roster) {
        if (emp.manager_id === myEmployeeId) ids.add(emp.id)
    }
    return ids
}
